import { Metamodel } from 'app/model/base/model';

import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { AzurePostgreSqlLinkedService } from 'app/model/linkedservice/azure-db-postgre.linkedservice';
import { driverVersions } from 'app/registries/consts/tabular-consts';

/**
 * Azure HorizonDB is PostgreSQL wire-compatible, so it shares the exact same shape as
 * Azure Database for PostgreSQL. It is modeled as its own linked-service type
 * ('AzureHorizonDB') and inherits all attributes/behaviors from AzurePostgreSqlLinkedService.
 *
 * azureHorizonDBLinkedService instanceof AzurePostgreSqlLinkedService === true
 */
@Metamodel.model({
    name: adfModelTypeMap.azureHorizonDb.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureHorizonDB_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureHorizonDB_DisplayText)
    ]
})
export class AzureHorizonDBLinkedService extends AzurePostgreSqlLinkedService {
    // Internal serialization selector only (v1 = legacy connection string, v2 = structured); HorizonDB has no user-facing version and always uses v2.
    public override version: driverVersions = driverVersions.v2;
}
